export interface MatchesTextQueryOptions {
  /** Default true. Set false to preserve legacy filters that skip trim on the query. */
  trim?: boolean;
}

/**
 * Case-insensitive substring match across optional text fields.
 * Returns false when the normalized query is non-empty and no field matches.
 */
export function matchesTextQuery(
  query: string,
  fields: readonly (string | null | undefined)[],
  options?: MatchesTextQueryOptions,
): boolean {
  const trim = options?.trim ?? true;
  const normalized = trim ? query.trim().toLowerCase() : query.toLowerCase();
  if (!normalized) {
    return true;
  }
  return fields.some((field) => field?.toLowerCase().includes(normalized));
}
